import * as types from './mutation-types'

export default {
  [types.SET_ME]: (state, obj) => {
    state.user = obj.user
  },
  [types.SET_LIST]: (state, obj) => {
    state.list = obj.list
  },
  [types.SET_NEW]: (state, obj) => {
    state.list.push(obj.newUser)
  },
  [types.SET_UPDATED]: (state, obj) => {
    let {updatedUser}  = obj
    state.list = state.list.map( item => item.id === updatedUser.id ? updatedUser : item)
  },
  [types.SET_SELECTED]: (state, obj) => {
    state.userSelected = obj._user
  },
}




// WEBPACK FOOTER //
// ./src/features/User/store/mutations.js